import { useState } from 'react';
import SampleListView from './SampleListView';

import axios from 'axios';

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV
const SampleListViewCharged = (props) => {
  const orderCode = props.orderCode;

  // const [chargedSamples, setChargedSamples] = useState([]);

  async function setChargedSamples(chargedSamples) {
    const res = await axios.post(API_ENDPOINT + '/samples/updateChargedSamples', {
      orderCode: orderCode,
      chargedSamples: chargedSamples ?? [],
    });
  }

  return (
    <SampleListView title={'Charged Samples - Billing'} buttonTitle={'Sample Pricing'} selectKey={'charged'} orderCode={orderCode} selectFunction={setChargedSamples} />
  );
};

export default SampleListViewCharged;
